import { FLASH_MESSAGE_ADD, FLASH_MESSAGE_REMOVE, FLASH_MESSAGES_LOADED } from "../constants";

const initialState = [];

export const flashMessages = (state = initialState, action) => {
    switch(action.type) {
        case FLASH_MESSAGES_LOADED:
            return state?.map(m => ({
                ...m,
                messageId: crypto.randomUUID(),
            })) ?? [];
        case FLASH_MESSAGE_REMOVE:
            return state.filter(m => m.messageId !== action.payload.messageId);
        case FLASH_MESSAGE_ADD:
            return [...state, action.payload];
        default:
            return state;
    }
}